import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Tooltip from "@mui/material/Tooltip";

function MuxDownloadAction({ item }: any) {
  const handleDownload = async () => {
    try {
      if (!item.mux_asset_id) {
        console.error("No Mux asset ID found for download");
        return;
      }
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/performances/mux/${item.mux_asset_id}/download/${item.performance_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        }
      );

      const result = await response.json();
      
      if (result.success && result.data.download_url) {
        const link = document.createElement("a");
        link.href = result.data.download_url;
        link.download = result.data.filename || item.talktape_video_title || "talktape.mp4";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Download failed:", result.message);
      }
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  if (!item.mux_asset_id) return null;

  return (
    <Tooltip title="Download Talktape" enterDelay={0} leaveDelay={0}>
    <span>
      <FileDownloadOutlinedIcon
        className="music-icon download"
        onClick={handleDownload}
        style={{ cursor: "pointer" }}
      />
    </span>
    </Tooltip>
  );
}

export default MuxDownloadAction;